module.exports = __webpack_public_path__ + "img/432750.1e9fa2bc.svg";